import { Connection, Proxy, hubConnection } from "signalr-no-jquery";
import { IInstantMessageListItem, IInstantMessageListItemData, InstantMessageListItem } from "../instantMessage/instantMessageListItem";
import { IInstantMessageChannelItemData, InstantMessageChannelItem, IInstantMessageChannelItem } from "../instantMessage/instantMessageChannelItem";
import { ISignalrNotification, SignalrNotification } from "../common/signalrNotification";

export interface ISignalROperations {
    onUpdateInstantMessageListLine?: (item: IInstantMessageListItem) => void;
    onRemoveInstantMessageChannel?: (instantMessageChannelId: string) => void;
    onUpdateInstantMessageChannel?: (channel: IInstantMessageChannelItem) => void;
    onShowNotification?: (notification: ISignalrNotification) => void;
}

export class SignalRConnectionManager {
    private connection: Connection;
    private hub: Proxy;
    private openingConnection: boolean;

    //appConfig.rootUrl
    openConnection = (rootUrl: string, operations: ISignalROperations, signalRToken: string = null) => {
        if (this.openingConnection || this.connection) return;
        this.openingConnection = true;
        this.connection = hubConnection(rootUrl.substr(0, rootUrl.length - 1), { qs: "st=" + (signalRToken ?? "") });
        this.hub = this.connection.createHubProxy("SignalRHub");
        if (operations.onUpdateInstantMessageListLine) {
            this.hub
                .off("updateInstantMessageListLine")
                .on("updateInstantMessageListLine", (item: IInstantMessageListItemData) => {
                    if (!item) return;
                    operations.onUpdateInstantMessageListLine(new InstantMessageListItem(item));
                });
        }
        if (operations.onRemoveInstantMessageChannel) {
            this.hub
                .off("removeInstantMessageChannel")
                .on("removeInstantMessageChannel", (instantMessageChannelId: string) => {
                    if (!instantMessageChannelId) return;
                    operations.onRemoveInstantMessageChannel(instantMessageChannelId);
                });
        }
        if (operations.onUpdateInstantMessageChannel) {
            this.hub
                .off("updateInstantMessageChannel")
                .on("updateInstantMessageChannel", (channel: IInstantMessageChannelItemData) => {
                    if (!channel) return;
                    operations.onUpdateInstantMessageChannel(new InstantMessageChannelItem(channel));
                });
        }
        if (operations.onShowNotification) {
            this.hub
                .off("showNotification")
                .on("showNotification", (item: ISignalrNotification) => {
                    if (!item) return;
                    operations.onShowNotification(new SignalrNotification(item));
                });
        }
        this.connection.start()
            .done(() => {
                this.openingConnection = false;
                console.log("[App] SignalR connected, id = " + this.connection.id);
            }).fail((error) => {
                this.openingConnection = false;
                this.connection = null;
                this.hub = null;
                console.log("[App] SignalR connection error = " + error);
            });
    };

    closeConnection = () => {
        if (!this.connection) return;
        this.connection.stop(true, true);
        this.connection = null;
        this.hub = null;
    };
}